import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createBookingExpense,
  deleteBookingExpense,
  getBookingExpenseById,
  getBookingExpenses,
  updateBookingExpense,
} from "./booking-expenses.service";

export const useGetBookingExpenses = (params) => {
  return useQuery({
    queryKey: ["booking-expenses", params],
    queryFn: () => getBookingExpenses(params),
  });
};

export const useGetBookingExpenseById = (bookingExpenseId) => {
  return useQuery({
    queryKey: ["booking-expenses", bookingExpenseId],
    queryFn: () => getBookingExpenseById(bookingExpenseId),
    enabled: Boolean(bookingExpenseId),
  });
};

export const useCreateBookingExpenseMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createBookingExpense,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["booking-expenses"] });
    },
  });
};

export const useUpdateBookingExpenseMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ bookingExpenseId, bookingExpenseData }) =>
      updateBookingExpense(bookingExpenseId, bookingExpenseData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["booking-expenses"] });
    },
  });
};

export const useDeleteBookingExpenseMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteBookingExpense,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["booking-expenses"] });
    },
  });
};
